import * as React from 'react';
import { IOktaMfaModel } from './Model';
import YubicoVerify from './YubicoVerify';

interface IYubicoSetupProps {
    okta: IOktaMfaModel;
    onClick: () => void;
    enrollState: {
        isEnrollSelected: boolean;
        enrollFactor: string;
    };
}

/*
 * This component will be used during enrollment process where
 * user is shown multiple factors to enroll into. Every Factor
 * will have its setup component
 */
class YubicoSetup extends React.Component<IYubicoSetupProps> {
    render() {
        const { strings } = this.props.okta.oktaMfa;
        let setupPage;
        const setUpPageTitle = strings.factorEnrollmentTitle.replace('[FACTOR_NAME]', strings.yubicoOtpFactor);
        if (this.props.enrollState.isEnrollSelected) {
            setupPage = (
                <div>
                    <h2>{setUpPageTitle}</h2>
                    <YubicoVerify okta={this.props.okta} />
                </div>
            );
        } else {
            setupPage = (
                <div>
                    <span className="button-container">
                        <input
                            type="submit"
                            className="apmui-button apmui-button-submit apmui-button-long"
                            id="submit"
                            name="submit"
                            value={strings.yubicoOtpFactor}
                            onClick={this.props.onClick}
                        />
                    </span>
                </div>
            );
        }

        return <div>{setupPage}</div>;
    }
}

export default YubicoSetup;
